<section id="CampaignSelectorPage">
   <div
      class="spinner"
      *ngIf="isLoadingAuth">
      <div
         class="spinner-border"
         role="status">
         <span class="sr-only">Loading...</span>
      </div>
   </div>
   <div
      class="container"
      *ngIf="!isLoadingAuth">
      <div class="d-flex flex-column align-items-center pt-5">
         <div
            class="col-md-7 d-flex"
            *ngIf="!isLoadingAuth && currentUser.practices.length >= 1">
            <vc-practice-select
               [autoselect]="true"
               (onSelected)="onPracticeSKeySelected($event)"></vc-practice-select>
         </div>

         <div
            class="col-md-7 d-flex"
            *ngIf="currentPractice">
            <div
               class="card mb-5"
               style="width: 100%">
               <div class="box-heading">
                  <h4 class="card-header">Select Campaign</h4>
               </div>
               <div
                  *ngIf="!isLoadingCalls"
                  class="card-body"
                  style="padding-top: 10px">
                  <div class="list-group">
                     <div class="table-responsive">
                        <table class="table custom-table contact-table">
                           <thead>
                              <tr>
                                 <th
                                    class="campTH"
                                    style="width: 48%; padding-left: 10px; text-align: left">
                                    Campaign
                                 </th>
                                 <th
                                    class="campTH"
                                    style="width: 16%; text-align: right">
                                    <i>Total</i>
                                    <br />
                                    Text/Calls Made
                                 </th>
                                 <th
                                    class="campTH"
                                    style="width: 17%; text-align: right">
                                    Today's
                                    <br />
                                    Total Text/Calls
                                 </th>
                                 <th
                                    class="campTH"
                                    style="width: 19%; text-align: right; padding-right: 18px; color: #00a876">
                                    Today's
                                    <br />
                                    Pending Text/Calls
                                 </th>
                              </tr>
                           </thead>
                        </table>
                     </div>

                     <a
                        *ngFor="let c of campaigns"
                        [routerLink]="generateLink(c)"
                        class="list-group-item list-group-item-action"
                        style="padding: 0px">
                        <app-campaign-item [campaign]="c"></app-campaign-item>
                     </a>
                  </div>
               </div>
               <div
                  *ngIf="isLoadingCalls"
                  class="card-body">
                  <div
                     class="spinner"
                     *ngIf="isLoadingCalls">
                     <div
                        class="spinner-border"
                        role="status">
                        <span class="sr-only">Loading...</span>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</section>
